import { ReactElement, useMemo } from 'react';
import { Card, Stack, Radio, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import { DialogRebillOrdersCardModeProps } from './types';
import { FIELDS_NAME, getInitialValues } from './utils';
import {
  DialogRebillOrdersCardModeContent,
  DialogRebillOrdersRecommendedChip,
} from './styles';

const DialogRebillOrdersCardMode = ({
  mode,
  title,
  description,
  isRecommeded,
  children,
}: DialogRebillOrdersCardModeProps): ReactElement => {
  const { values, handleChange } =
    useFormikContext<ReturnType<typeof getInitialValues>>();

  const isChecked = useMemo(
    () => values[FIELDS_NAME.MODE] === mode,
    [mode, values],
  );

  return (
    <Card variant="outlined">
      <DialogRebillOrdersCardModeContent>
        <Stack spacing={0.5} direction="row" alignItems="flex-start">
          <Radio
            checked={isChecked}
            onChange={handleChange}
            value={mode}
            name={FIELDS_NAME.MODE}
          />

          <Stack spacing={2} flex={1} paddingTop={1}>
            <Stack spacing={1}>
              <Stack
                spacing={1}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography
                  variant="body1"
                  color="primary.main"
                  fontWeight="bold"
                  flex={1}
                >
                  {title}
                </Typography>

                {isRecommeded && (
                  <DialogRebillOrdersRecommendedChip
                    label="RECOMENDADA"
                    variant="filled"
                  />
                )}
              </Stack>

              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            </Stack>

            {children}
          </Stack>
        </Stack>
      </DialogRebillOrdersCardModeContent>
    </Card>
  );
};

export default DialogRebillOrdersCardMode;
